<template>
  <div>
    <div class="header-container">
      <div class="header-bar">
        <div class="header-bar-inner">
          <router-link :to="{name: 'shopnetHome'}" class="logo-container">
            <img :src="sellerLogoUrl" class="shop-logo">
          </router-link>
          <router-link to="/cart">
            <button class="btn btn-tertiary">
              <i class="fas fa-arrow-left" />
              Back to Cart
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <main>
      <div class="checkout-container">
        <div class="checkout-details">
          <h1 class="checkout-header">
            Checkout
          </h1>
          <div id="open-section-1" :class="{'checkout-section': true, clickable: currentStep > 1, active: activeSection(1)}" @click="goToPreviousStep(1)">
            <div>
              <i v-if="currentStep > 1" class="fas fa-check-circle" />
              Customer Details
            </div>
            <div> <i class="fas fa-chevron-down" /> </div>
          </div>
          <CustomerDetails v-show="activeSection(1)" :cart-pid="cartPid" @sectionComplete="goToNextStep" />

          <div id="open-section-2" :class="{'checkout-section': true, clickable: currentStep > 2, active: activeSection(2)}" @click="goToPreviousStep(2)">
            <div>
              <i v-if="currentStep > 2" class="fas fa-check-circle" />
              Shipping Details
            </div>
            <div v-if="currentStep > 1">
              <i class="fas fa-chevron-down" />
            </div>
          </div>
          <ShippingDetail
            v-show="activeSection(2)"
            v-if="checkoutPreferences.allowed_shipping_methods"
            :cart-pid="cartPid"
            :checkout-preferences="checkoutPreferences"
            :pickup-instructions="checkoutPreferences.allowed_shipping_methods.pickup_instructions"
            @sectionComplete="goToNextStep"
          />

          <div id="optional-note-section" :class="{'checkout-section': true, clickable: currentStep > 3, active: activeSection(3)}" @click="goToPreviousStep(3)">
            <div>
              <i v-if="currentStep > 3" class="fas fa-check-circle" />
              Optional Notes on the Order
            </div>
            <div v-if="currentStep > 2">
              <i class="fas fa-chevron-down" />
            </div>
          </div>
          <OptionalNote v-show="activeSection(3)" :cart-pid="cartPid" @sectionComplete="goToNextStep" />

          <div :class="{'checkout-section': true, active: activeSection(4)}">
            Payment
            <div v-if="activeSection(4)">
              <i class="fas fa-chevron-down" />
            </div>
          </div>
          <PaymentContainer
            v-if="activeSection(4) && checkoutPreferences.allowed_shipping_methods"
            :cart-pid="cartPid"
            :stripe-api-key="stripeApiKey"
            :stripe-account-id="stripeAccountId"
            :grand-total="cartGrossPrice"
            :checkout-preferences="checkoutPreferences"
            :allowed-methods="checkoutPreferences.allowed_payment_methods"
          />
        </div>

        <div class="checkout-price">
          <h1>Your order</h1>
          <div class="checkout-total-section">
            <div class="section">
              <div>
                <p class="title">
                  Subtotal:
                </p>
                <div v-if="hasGst">
                  (incl. {{ productsGstPrice }} GST)
                </div>
              </div>
              <div style="text-align: right">
                <div class="sub-price">
                  {{ productsGrossPrice }}
                </div>
              </div>
            </div>

            <div v-if="cartShippingMethod" class="section">
              <p class="title">
                {{ cartShippingMethod }}:
              </p>
              <div class="sub-price">
                {{ deliveryGrossPrice }}
              </div>
            </div>

            <div class="section">
              <div>
                <p class="title">
                  Total:
                </p>
                <div v-if="hasGst">
                  (incl. GST)
                </div>
              </div>
              <div class="gross">
                {{ cartGrossPrice }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PaymentContainer from '../checkout/pay';
import ShippingDetail from '../checkout/shipping_details';
import CustomerDetails from '../checkout/customer_details';
import OptionalNote from '../checkout/optional_note';
import { fetchCartPreferences } from "../../../shopfront/cartDataService";
export default {
  components: { PaymentContainer, ShippingDetail, CustomerDetails, OptionalNote },
  props: {
    sellerLogoUrl: { required: true, type: String },
    stripeApiKey: { required: true, type: String },
    stripeAccountId: { required: false, type: String, default: undefined },
  },
  data() {
    return {
      currentStep: 1,
      checkoutPreferences: {},
    };
  },
  computed: {
    cartPid: function() {
      return this.$store.state.cartId;
    },
    cartGrossPrice: function() {
      return this.$store.state.cartGrossPrice;
    },
    cartShippingMethod: function() {
      return this.$store.state.shippingMethod;
    },
    hasGst: function() {
      return this.productsGstPrice !== '$0.00';
    },
    deliveryGrossPrice: function() {
      let val = this.$store.state.deliveryGrossPrice;
      if (val === "$0.00") {
        return 'FREE';
      } else {
        return val;
      }
    },
    productsGstPrice: function() {
      return this.$store.state.productsGstPrice;
    },
    productsGrossPrice:  function() {
      return this.$store.state.productsGrossPrice;
    },
  },
  mounted: function() {
    let vm = this;

    if (!this.$store.state.cartId || !this.$store.getters.cartTotal) {
      return vm.$router.push({ path: '/' });
    }

    fetchCartPreferences(this.cartPid, this.$store.state.sellerPid,function(response) {
      vm.checkoutPreferences = response;
    });
  },
  methods: {
    activeSection: function(step) {
      return step === this.currentStep;
    },
    goToNextStep: function() {
      this.currentStep += 1;
    },
    goToPreviousStep: function(step) {
      if (this.currentStep > step) {
        this.currentStep = step;
      }
    },
  },
};
</script>
